import { useEffect, useState } from 'react';

const INCLUDE_RENT_ROLL_INPUT_ID = 'property_include_rent_roll';

const readIncludeRentRoll = (): boolean => {
  const input = document.getElementById(INCLUDE_RENT_ROLL_INPUT_ID);
  return input instanceof HTMLInputElement ? input.checked : true;
};

export const useIncludeRentRoll = (): boolean => {
  const [includeRentRoll, setIncludeRentRoll] = useState<boolean>(() => readIncludeRentRoll());

  useEffect(() => {
    const input = document.getElementById(INCLUDE_RENT_ROLL_INPUT_ID);
    if (!(input instanceof HTMLInputElement)) return undefined;
    const onChange = () => setIncludeRentRoll(input.checked);
    input.addEventListener('change', onChange);
    return () => input.removeEventListener('change', onChange);
  }, []);

  return includeRentRoll;
};
